"use client"

import {
  useProfileActiveLinkChecker,
  useProfilePageHref,
} from "@/app/navigation/profile"
import type { ProfilePageType } from "@/app/navigation/profile/profile-page-type"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import { NavigationTrigger, cn } from "@rarible_int/anaconda_ui_components"
import BaseLink from "next/link"

export function ProfilePageLink(props: {
  children: React.ReactNode
  pageType: ProfilePageType
  walletAddress: UnionAddress
}) {
  const active = useProfileActiveLinkChecker(
    props.walletAddress,
    props.pageType,
  )
  const href = useProfilePageHref(props.walletAddress, props.pageType)

  return (
    <BaseLink href={href}>
      <NavigationTrigger active={active}>{props.children}</NavigationTrigger>
    </BaseLink>
  )
}
